// seems like we need these...

export const FOOTER = 2
export const SLIDER = FOOTER + 1
